import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '作品分类', path: '/category' },
  { name: '摄影指南', path: '/articles' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl md:text-2xl font-heading tracking-wide transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              秀人写真
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm whitespace-nowrap transition-colors hover:opacity-80 ${
                  location.pathname === link.path
                    ? scrolled ? 'text-primary-500 font-medium' : 'text-white font-medium'
                    : scrolled ? 'text-foreground-700' : 'text-white/85'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="#contact"
              className="whitespace-nowrap px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              预约拍摄
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200">
            <div className="flex flex-col py-4 px-4 gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm py-2 transition-colors ${
                    location.pathname === link.path
                      ? 'text-primary-500 font-medium'
                      : 'text-foreground-700'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="#contact"
                className="text-center py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
              >
                预约拍摄
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}